const ths = [
  {
    id: 0,
    label: '',
    intlKey: '',
    sortableId: '',
    selector: true
  },
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'participantPerson.id'
  },
  {
    id: 2,
    label: 'First name',
    intlKey: 'table.first_name',
    sortableId: 'participantPerson.firstName'
  },
  {
    id: 3,
    label: 'Last name',
    intlKey: 'table.last_name',
    sortableId: 'participantPerson.lastName'
  },
  {
    id: 4,
    label: 'Registration',
    intlKey: 'table.registration',
    sortableId: 'participantPerson.createdAt'
  },
  {
    id: 5,
    label: 'Level',
    intlKey: 'table.level',
    sortableId: 'award.awardLevel.value'
  },
  {
    id: 6,
    label: 'Email',
    intlKey: 'table.email',
    sortableId: 'participantPerson.email'
  },
  {
    id: 7,
    label: 'Award Centre',
    intlKey: 'table.award_unit',
    sortableId: 'organization.name'
  },
  {
    id: 8,
    label: 'Delete',
    intlKey: 'table.delete',
    sortable: false
  },
  {
    id: 9,
    label: 'Assign',
    intlKey: 'table.assign',
    sortable: false
  }
]

export default ths

export const bulkForm = 'tasks-unassignedParticipants-bulkChange'
